import { PARKING_SEARCH_TYPE } from '~/utilities/constants'
import { trackEvent } from './trackhome'

const EVENT = 'pay-nyc'

function track(isPayNYCFlow, step, tags = [], value) {
  if (!isPayNYCFlow) return
  trackEvent(EVENT, [`step:${step}`, ...tags], value)
}

function normalizeReason(reason) {
  if (!reason) return 'other'
  const normalized = String(reason).toLowerCase()
  if (normalized.includes('declin')) return 'declined'
  if (normalized.includes('already paid') || normalized.includes('pending payment')) {
    return 'already_paid'
  }
  if (normalized.includes('not found')) return 'not_found'
  if (normalized.includes('blocked')) return 'blocked'
  if (normalized.includes('booted') || normalized.includes('towed')) return 'booted_or_towed'
  if (normalized.includes('service unavailable') || normalized.includes('timeout')) {
    return 'service_unavailable'
  }
  if (normalized.includes('address')) return 'address_verification'
  return 'other'
}

export function landing(isPayNYCFlow, origin) {
  track(isPayNYCFlow, 'landing', origin ? [`origin:${origin}`] : [])
}

export function search(isPayNYCFlow, searchType, plateState) {
  const searchBy =
    searchType === PARKING_SEARCH_TYPE.ticketId ? 'ticket' : searchType
  const tags = [`search_by:${searchBy}`]
  if (searchType === PARKING_SEARCH_TYPE.plate && plateState) {
    tags.push(`state:${plateState}`)
  }
  track(isPayNYCFlow, 'search', tags)
}

export function results(isPayNYCFlow, ticketCount) {
  track(
    isPayNYCFlow,
    'results',
    [`found:${ticketCount > 0 ? 'yes' : 'no'}`],
    ticketCount
  )
}

export function noResultNotify(isPayNYCFlow, searchType, plateState) {
  const searchBy =
    searchType === PARKING_SEARCH_TYPE.ticketId ? 'ticket' : searchType
  const tags = [`search_by:${searchBy}`]
  if (searchType === PARKING_SEARCH_TYPE.plate && plateState) {
    tags.push(`state:${plateState}`)
  }
  track(isPayNYCFlow, 'no_result_notify', tags)
}

export function checkout(isPayNYCFlow, paySubtotal) {
  track(isPayNYCFlow, 'checkout', [], paySubtotal)
}

export function payAttempt(isPayNYCFlow, processor, paySubtotal) {
  track(isPayNYCFlow, 'pay_attempt', [`processor:${processor}`], paySubtotal)
}

export function paySuccess(isPayNYCFlow, processor, totalPaid, serviceFee) {
  track(isPayNYCFlow, 'pay_success', [`processor:${processor}`, 'amount:total'], totalPaid)
  track(isPayNYCFlow, 'pay_success', [`processor:${processor}`, 'amount:service_fee'], serviceFee)
}

export function payFailure(isPayNYCFlow, processor, paySubtotal, reason) {
  track(
    isPayNYCFlow,
    'pay_failure',
    [`processor:${processor}`, `reason:${normalizeReason(reason)}`],
    paySubtotal
  )
}

export function trackPayFlowFailure(rootStore, reason) {
  if (!rootStore.ui.isPayNYCFlow || !rootStore.parkingFlow.flow.isPayFlow) return
  payFailure(
    rootStore.ui.isPayNYCFlow,
    rootStore.payment.user.paymentProcessor.type,
    rootStore.parkingFlow.results.paySubtotal,
    reason
  )
}

export function oneTapShown(isPayNYCFlow) {
  track(isPayNYCFlow, 'auth', ['method:one_tap', 'action:shown'])
}

export function oneTapSuccess(isPayNYCFlow) {
  track(isPayNYCFlow, 'auth', ['method:one_tap', 'action:success'])
}

export function magicLinkRequested(isPayNYCFlow) {
  track(isPayNYCFlow, 'auth', ['method:magic_link', 'action:requested'])
}

export function codeLoginSuccess(isPayNYCFlow) {
  track(isPayNYCFlow, 'auth', ['method:login_code', 'action:success'])
}

export function googleCheckoutLogin(isPayNYCFlow) {
  track(isPayNYCFlow, 'auth', ['method:google', 'action:checkout_login'])
}
